import store from '@/state/store';
//clientdocadmin/uploadsop
//client_sop_id and sop
import Vue from 'vue';
const getDefaultState = () => {
    return {
        sops: null, // sop documents loaded for a group
        notifications: null, //list of sop related notifications
        sop_groups:null, //list of sop groups
        sop_data: null, //selected sop data
        selected_sop_group: null, //id of selected sop group
        context_menu_id: -1, // id of right clicked sop (used for popover)
        action_id: null,

        modules: [],

        is_loading_documents: false,
        sop_stats: null,
        workflows: [],
        assignable_sops: [],
        active_job_data: {}, 

        client_sop_data: null,
        all_attachments:null,
        distribution_clients: null,
        distribution_sop: null,
    }
}

export const state = getDefaultState();

export const mutations = {
    // update builder mode flag for selected sop
    updateSopDocumentMode(state, builder_mode_boolean){
        // need vue.set due to reactivity issues
        Vue.set(state.sop_data, 'builder_enabled', builder_mode_boolean);
    },
    pushRevisionToRevisionArray(state, revision){
        //let client_revisions = state.sop_data.client_revisions
        state.sop_data.client_revisions.push(revision);
    },

    setNotifications(state, payload){
        state.notifications = payload;
    },
    setActiveJobData(state, payload) {
        console.log("set payload", payload);
        state.active_job_data = payload;
    },
    //eslint-disable-next-line
    setSops(state, payload){
        let module_idx = state.modules.findIndex( module => {
            if(payload.client_sop_module_id != undefined){
                return module.id == payload.client_sop_module_id;
            }
            else{
                return module.id == payload.sop_module_id
            }
            
        })
        console.log(state.modules[module_idx].groups)
        if(module_idx != -1){
            let group_idx = state.modules[module_idx].groups.findIndex( group => {
                return group.id == payload.id;
            })
            if(group_idx != -1){
                state.modules[module_idx].groups[group_idx].sops = payload.sop_types;   
            }
        }
        //console.log('PORP',payload)
    },
    setSopsOld(state, payload){
        if(payload == null){
            state.sops = null;
            return;
        }
        let found_index = state.sop_groups.findIndex( group => {
            return payload.id == group.id;
        })
        if(found_index != -1){
            state.sop_groups[found_index]['sops'] = payload.sop_types;
        }
        state.sops = payload.sop_types;
    },
    setSelectedSopGroup(state, payload){
        state.selected_sop_group = payload;
    },
    setSopGroups(state, payload){
        state.sop_groups = payload;
    },
    setModules(state, payload){
        state.modules = payload;
    },
    //eslint-disable-next-line
    clearStore(state, payload){
        //state.sop_data = payload;
        Object.assign(state, getDefaultState());
    },
    setSopData(state, payload){
        state.sop_data = payload;
    },
    setRightClickMenuID(state, payload){
        state.context_menu_id = payload;
    },
    setActionID(state, payload){
        state.action_id = payload;
    },
    //eslint-disable-next-line
    resetStore(state, payload){
        Object.assign(state, getDefaultState());
        // state.sops = payload;
        // state.notifications = payload;
        // state.sop_groups = payload;
        // state.sop_data = payload;
        // state.selected_sop_group = payload;
        // state.context_menu_id = -1;
        // state.action_id = null;
    },

    setAllAttachments(state, payload){
        state.all_attachments = payload;
    },
    setDistributionClients(state, payload){
        state.distribution_clients = payload;
    },
    setDistributionSop(state, payload){
        state.distribution_sop = payload;
    },
    setSopStats(state, payload){
        state.sop_stats = payload;
    },
    setClientSopData(state, payload){
        state.client_sop_data = payload;
    },

    // workflows
    setWorkflows(state, payload){
        state.workflows = payload;
    },
    setAssignableSops(state, payload){
        state.assignable_sops = payload;
    },
    clearSopDataForGroup(state){
        state.selected_sop_group = null;
        if(state.sop_groups != null){
            state.sop_groups.forEach( group => { group['sops'] = [] });
        }
    }
}

export const actions = {
    updateSopDocumentMode({commit}, builder_mode_boolean){
        commit('updateSopDocumentMode', builder_mode_boolean);
    },
    loadClientSop({commit}, params){/* params.client_id, params.step_id */
        return new Promise((resolve, reject)=>{
            window.axios.get('api/ccbdocadmin/clientsop/'+params.type_id+'/'+params.client_id)
            .then((response)=>{
                commit('setClientSopData', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },
    loadSopData({commit}, id){
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin';
                break;
            }
            default :{
                api_string = 'clientdocadmin';
                break;
            }
        }
        return new Promise((resolve, reject)=>{
            window.axios.get(`api/${api_string}/soptype/${id}`)
            .then((response)=>{
                commit('setSopData', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    loadSops({commit}, id){
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin';
                break;
            }
            default :{
                api_string = 'clientdocadmin';
                break;
            }
        }
        return new Promise((resolve, reject)=>{
            //commit('setSops', null);
            window.axios.get(`api/${api_string}/sopgroup/${id}`)
            .then((response)=>{
                commit('setSops', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    //eslint-disable-next-line
    saveModule({}, payload){
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin';
                break;
            }
        }
        return new Promise((resolve, reject)=>{
            window.axios.post(`api/${api_string}/savesopmodule`, payload)
            .then(()=>{
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    //eslint-disable-next-line
    deleteModule({}, payload){
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin';
                break;
            }
        }
        return new Promise((resolve, reject)=>{
            window.axios.post(`api/${api_string}/deletesopmodule`, payload)
            .then(()=>{
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    loadModules({commit}, reset = false){
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin';
                break;
            }
            case 'client':{
                api_string = 'clientdocadmin';
                break;
            }
        }
        return new Promise((resolve, reject)=>{
            if(reset == true || api_string == ''){
                commit('setModules', []);
                resolve();
            }

            window.axios.get(`api/${api_string}/sopmodules/`)
            .then((response)=>{
                let data = response.data;
                data.forEach( item => {
                    console.log('data item', item)
                    let keys = Object.keys(item.groups);
                    let processed_data = [];
                    keys.forEach( key => {
                        console.log('key', key);
                        let key_item = item.groups[key];
                        key_item['sops'] = [];
                        processed_data.push(key_item);
                    })
                    // console.log("ITEM", item.client_sop_groups);
                    // item.client_sop_groups.forEach( group => {
                    //     group['sops'] = [];
                    // })
                    item['groups'] = processed_data;
                })

                /*data.forEach( el => {
                    delete el.groups;
                })*/

                commit('setModules', data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    loadSopGroups({commit}, reset = false){
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin';
                break;
            }
            default :{
                api_string = 'clientdocadmin';
                break;
            }
        }
        return new Promise((resolve, reject)=>{
            if(reset == true){
                commit('setSopGroups', null);
                resolve();
            }

            window.axios.get(`api/${api_string}/sopgroups/`)
            .then((response)=>{
                let data_object = response.data;
                let keys = Object.keys(response, response.data);
                let processed_data = [];
                keys.forEach( key => {
                    let item = data_object[key];
                    if(item == undefined){
                        return;
                    }
                    item['sops'] = [];
                    processed_data.push(item);
                })
                commit('setSopGroups', processed_data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    selectSopGroup({commit}, sop_group){
        return new Promise((resolve)=>{
            commit('setSelectedSopGroup', sop_group);
            resolve();
        });
    },
    clearSopStore({commit}){
        return new Promise((resolve) => {
            commit('clearStore', null);
            resolve();
        })
    },
    //eslint-disable-next-line
    approveSopRevision({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/approvesoprevision', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    previewSop({commit}, params){//{revision_id : 1}
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/previewsop', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    getSopLink({commit}, params){//{revision_id : 1}
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/previewsop', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    saveSopType({commit}, params){//*  "id": -1, | "sop_group_id": 2, | "name": "Test Type", | "sop_code": "SOP-TYPE-002"
        return new Promise((resolve, reject) => {
            let api_string = store.getters['clientAdmin/userType'] == 'admin' ? 'ccbdocadmin' : 'clientdocadmin';
            window.axios.post(`api/${api_string}/savesoptype`, params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    //eslint-disable-next-line
    saveSopRevisionLog({commit}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/savesoprevisionlog', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    //eslint-disable-next-line
    saveSopDistributionLog({commit}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/savesopdistlog', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    //eslint-disable-next-line
    toggleSopOverride({commit}, override_payload){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/togglesopoverride', override_payload)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    //eslint-disable-next-line
    saveSopHeader({}, header_payload){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/savesopheader', header_payload)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject(error);
            })
        })
    },
    loadNotifications({commit}){
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientadmin';
                break;
            }
            default :{
                api_string = 'clientuser';
                break;
            }
        }
        return new Promise((resolve, reject)=>{
            window.axios.get(`api/${api_string}/notifications`)
            .then((response)=>{
                commit('setNotifications', response.data);
                resolve();
            })
            .catch((e)=>{
                console.log(e)
                reject();
            })
        });
    },
    /*eslint-disable-next-line */
    deleteSopType({}, params){
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin';
                break;
            }
        }
        return new Promise((resolve, reject) => {
            window.axios.post(`api/${api_string}/deletesoptype`, params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    saveSopGroup({commit}, params){//* "id": -1 -- "parent_id": 0 -- "name": "Test Group"
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin';
                break;
            }
        }
        return new Promise((resolve, reject) => {
            window.axios.post(`api/${api_string}/savesopgroup`, params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    
    pushRevisionToRevisionArray({commit}, revision){
        commit('pushRevisionToRevisionArray', revision);
    },
    /*eslint-disable-next-line */
    saveSopRevision({commit}, params){
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin/savesoprevision';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin/saveclientsoprevision';
                break;
            }
        }
        return new Promise((resolve, reject) => {
            window.axios.post(`api/${api_string}`, params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    deleteSopGroup({commit}, params){//* 'id': 1
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin';
                break;
            }
        }
        return new Promise((resolve, reject) => {
            window.axios.post(`api/${api_string}/deletesopgroup`, params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    saveSopAttachment({commit}, params){
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin';
                break;
            }
        }
        return new Promise((resolve, reject) => {
            window.axios.post(`api/${api_string}/savesopattachment`, params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    // eslint-disable-next-line
    deleteSopAttachment({}, params) {
        let api_string = '';
        switch(store.getters['clientAdmin/userType']){
            case 'admin':{
                api_string = 'ccbdocadmin';
                break;
            }
            case 'client_admin':{
                api_string = 'clientdocadmin';
                break;
            }
        }
        return new Promise((resolve, reject) => {
            window.axios.post(`api/${api_string}/deleteattachment`, params )
            .then( (response) =>{
                resolve(response);
            })
            .catch((error)=>{
                reject(error);
            })
        })
    },
    clearSopsFromGroup({commit}){
        commit('clearSopDataForGroup');
    },
    /*eslint-disable-next-line */
    getPreviewB64({}, revision_id){//{revision_id : 1}
        return new Promise((resolve, reject) => {
            let api_string = store.getters['clientAdmin/userType'] == 'admin' ? 'ccbdocadmin' : 'clientdocadmin';
            window.axios({
                url: `api/${api_string}/b64preview/` + this.revision_data.client_revision_id,
                method: 'GET',
                responseType: 'blob',
            })
            .then((response) =>{
                resolve(response);
            })
            .catch((error)=>{
                reject(error);
            });
        });
    },
    /*eslint-disable-next-line */
    publishTemplateSop({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/ccbdocadmin/publishsop', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    //* Load module types, displayed in dropdown when adding a client
    loadSopStats({commit}, params){/* params.client_id, params.step_id */
        return new Promise((resolve, reject)=>{
            window.axios.get('api/ccbdocadmin/sopstats/' + params.id )
            .then((response)=>{
                commit('setSopStats', response.data);
                resolve();
            })
            .catch(()=>{
                reject();
            })
        })
    },
    setSopFromMenu({commit}, sop){
        return new Promise((resolve)=>{
            commit('setSopData', sop);
            resolve();
        });
    },
    /*eslint-disable-next-line */
    uploadSignedSop({commit}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/uploadSignedSop', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    setDocumentFlag({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientuser/saveactiontracking', params)
            .then( (response) =>{
                resolve(response.data);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    distributeSOP({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/distributesop', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    approveSopDistribution({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post('api/clientdocadmin/approvesopdist', params)
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },

    loadWorkflows({commit}, level_id = -1){
        return new Promise((resolve, reject) => {
            window.axios.get(`api/clientdocadmin/sopassignment/${level_id}` )
            .then( (response) =>{
                commit('setWorkflows', response.data)
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    loadAssignableSops({commit}, group_id = -1){
        return new Promise((resolve, reject) => {
            window.axios.get(`api/clientdocadmin/assignablesops/${group_id}` )
            .then( (response) =>{
                commit('setAssignableSops', response.data)
                resolve(response);
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    /*eslint-disable-next-line */
    assignSopToWorkflow({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post(`api/clientdocadmin/assignsop`, params )
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },
    // eslint-disable-next-line
    unassignSopToWorkflow({}, params){
        return new Promise((resolve, reject) => {
            window.axios.post(`api/clientdocadmin/unassignsop`, params )
            .then( () =>{
                resolve();
            })
            .catch((error)=>{
                console.log(error)
                reject();
            })
        })
    },



    //use to track active job actions from notification table 
    setActiveJobInfo({commit}, params) {
        return new Promise((resolve)=>{
            console.log("set to", params);
            commit('setActiveJobData', params);
            resolve();
        });
    },

    //* id of the document item that was right clicked
    setContextMenuID({commit}, id){
        return new Promise((resolve)=>{
            commit('setRightClickMenuID', id);
            resolve();
        });
    },

    setActionItemID({commit}, id){
        return new Promise((resolve)=>{
            commit('setActionID', id);
            resolve();
        });
    },

    clearAll({commit}){
        return new Promise((resolve) => {
            commit('resetStore', null);
            resolve();
        })
    },

}